import { render, staticRenderFns } from "./TableCardSkeleton.vue?vue&type=template&id=66fb2456&lang=pug&"
import script from "./TableCardSkeleton.vue?vue&type=script&lang=js&"
export * from "./TableCardSkeleton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports